if (!customElements.get('custom-mobile-gallery')) {
  customElements.define('custom-mobile-gallery', class CustomMobileGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.container = this.querySelector('.product__media');
      this.thumbs = document.querySelectorAll('.product-thumbnails__item-link');
      this.mediaItems = this.querySelectorAll('.product__media-item');
      this.prevBtn = this.querySelector('.slider-nav-btn.prev');
      this.nextBtn = this.querySelector('.slider-nav-btn.next');

      if (!this.container) return;

      this.initObserver();
      this.initEvents();
    }

    initObserver() {
      const observerOptions = {
        root: this.container,
        threshold: 0.6
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('video');
          if (entry.isIntersecting) {
            const mediaId = entry.target.getAttribute('data-media-item-id');
            this.syncThumbnails(mediaId);
            if (video) {
              video.play().catch(() => {});
            }
          } else {
            if (video) {
              video.pause();
            }
          }
        });
      }, observerOptions);

      this.mediaItems.forEach((item) => this.observer.observe(item));
    }

    syncThumbnails(mediaId) {
      this.thumbs.forEach((thumb) => {
        const thumbId = thumb.getAttribute('data-thumbnail-id');
        if (thumbId === mediaId) {
          this.thumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          thumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      });
    }

    goToSlide(direction) {
      const items = Array.from(this.mediaItems);
      const total = items.length;
      if (total === 0) return;

      const currentIndex = Math.round(this.container.scrollLeft / this.container.offsetWidth);
      const nextIndex = (currentIndex + direction + total) % total;

      this.container.scrollTo({
        left: items[nextIndex].offsetLeft,
        behavior: 'smooth'
      });
    }

    initEvents() {
      // Thumbnail Tıklama
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const mediaId = thumb.getAttribute('data-thumbnail-id');
          const targetMedia = this.querySelector(`[data-media-item-id="${mediaId}"]`);
          if (targetMedia) {
            this.container.scrollTo({
              left: targetMedia.offsetLeft,
              behavior: 'smooth'
            });
          }
        });
      });

      // Ok Butonları
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.goToSlide(-1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.goToSlide(1);
        });
      }
    }
  });
}